<template>
  <svg
    class="site-arrow-up-right"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 12 12 4" />
    <path d="M6.25 4H12v5.75" />
  </svg>
</template>

<script>
export default {
  name: 'ArrowUpRightIcon',
};
</script>

<style scoped>
.site-arrow-up-right {
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  flex: 0 0 auto;
  overflow: visible;
  stroke: currentColor;
  stroke-width: 1.45;
  stroke-linecap: round;
  stroke-linejoin: round;
  transform: translateZ(0);
}
</style>
